module.exports = __webpack_public_path__ + "img/SaveButton.b1e667e6.jpg";